import React from 'react';
import { Form, Input, InputNumber, Select, Button, Space, message } from 'antd';

const { Option } = Select;

interface Content {
  id: number;
  fileId: string;
  filename: string;
  contentType: string;
  resolution?: string;
  duration?: number;
  bitRate?: number;
  metadata?: any;
}

interface ContentEditFormProps {
  content: Content;
  onSubmit: (values: any) => void;
  onCancel: () => void;
}

const ContentEditForm: React.FC<ContentEditFormProps> = ({ content, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values: any) => {
    try {
      await onSubmit(values);
    } catch (error) {
      message.error('保存失败');
    }
  };

  const handleFinish = async () => {
    try {
      const values = await form.validateFields();
      await handleSubmit(values);
    } catch (error) {
      // Validation error will be shown automatically
    }
  };

  // Convert metadata to string if it exists
  const initialMetadata = content.metadata ?
    (typeof content.metadata === 'string' ? content.metadata : JSON.stringify(content.metadata, null, 2)) :
    '';

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{
        filename: content.filename,
        contentType: content.contentType,
        resolution: content.resolution,
        duration: content.duration,
        bitRate: content.bitRate,
        metadata: initialMetadata,
      }}
    >
      <Form.Item label="文件ID">
        <Input value={content.fileId} disabled />
      </Form.Item>

      <Form.Item
        label="文件名"
        name="filename"
        rules={[{ required: true, message: '请输入文件名' }]}
      >
        <Input placeholder="例如：示例视频.mp4" />
      </Form.Item>

      <Form.Item
        label="内容类型"
        name="contentType"
        rules={[{ required: true, message: '请选择内容类型' }]}
      >
        <Select>
          <Option value="video">视频</Option>
          <Option value="audio">音频</Option>
          <Option value="document">文档</Option>
        </Select>
      </Form.Item>

      <Form.Item label="分辨率" name="resolution">
        <Input placeholder="例如：1920x1080 (可选)" />
      </Form.Item>

      <Form.Item label="时长 (秒)" name="duration">
        <InputNumber min={0} placeholder="例如：3600 (可选)" />
      </Form.Item>

      <Form.Item label="码率 (bps)" name="bitRate">
        <InputNumber min={0} placeholder="例如：5000000 (可选)" />
      </Form.Item>

      <Form.Item label="元数据 (JSON)" name="metadata">
        <Input.TextArea rows={3} placeholder='{"title": "My Video"} (可选)' />
      </Form.Item>

      <Form.Item>
        <Space style={{ float: 'right' }}>
          <Button onClick={onCancel}>取消</Button>
          <Button type="primary" htmlType="submit">
            保存
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ContentEditForm;
